export const ReferralSource = {
  DIRECT: 'DIRECT_REFERRALS',
  SUB: 'SUB_IB_REFERRALS',
};
